<template>
  <b-card>
    <b-alert show variant="warning">
      <h5>قبل از پرداخت به موارد زیر توجه نمایید</h5>
      <ul>
        <li>نام مالک کیف پول و مالک حساب باید یکسان باشد</li>
        <li>قبل از پرداخت حتما شماره شبا را در سیستم بانکی کشور تست نموده و از اطلاعات مالک حساب اطمینان حاصل نمایید</li>
      </ul>
    </b-alert>
    <b-row>
      <b-col>
        <b-form-group id="wallet_id-gr" label="کیف پول:" label-for="wallet_id">
          <div
            class="form-control"
          >{{settelment.wallet.wallet_name}} ({{settelment.wallet.user.fa_name + ' ' + settelment.wallet.user.fa_family}})</div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="mdid22_status-gr" label="وضعیت:" label-for="mdid22_status">
          <MDDropdown v-bind:group="22" v-model="settelment.mdid22_status"></MDDropdown>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="price-gr" label="مبلغ:" label-for="price">
          <b-form-input id="price" v-model="settelment.price" required></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="shaba_number-gr" label="شماره شبا:" label-for="shaba_number">
          <div class="form-control">{{settelment.user_card.shaba_number}}</div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="user-gr" label="نام مالک حساب:" label-for="user">
          <div
            class="form-control"
          >{{settelment.user_card.user.fa_name + ' ' + settelment.user_card.user.fa_family}}</div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="account_number-gr" label="شماره حساب:" label-for="account_number">
          <div class="form-control">{{settelment.user_card.account_number}}</div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="bank_name-gr" label="نام بانک:" label-for="bank_name">
          <div class="form-control">{{settelment.user_card.bank_name.title}}</div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="danger" v-b-modal.AddDoc>ثبت سند حسابداری</b-button>
        <b-button variant="primary" class="ml-3">ذخیره</b-button>
      </b-col>
    </b-row>

    <b-modal
      id="AddDoc"
      title="ثبت سند حسابداری مربوط به پرداخت وجه کیف پول"
      @ok="SaveDoc()"
      ok-title="ذخیره"
      cancel-title="انصراف"
    >
      <b-form-group id="refCode-group-8" label="کد رهگیری" label-for="refCode-8">
        <b-form-input id="refCode-8" v-model="doc.refCode" placeholder="کد رهگیری"></b-form-input>
      </b-form-group>
      <b-form-group id="bank-group-8" label="بانک پرداخت کننده" label-for="bank-8">
        <b-form-select :options="detaileds" v-model="doc.detailed_id"></b-form-select>
      </b-form-group>
    </b-modal>
  </b-card>
</template>
<script>
import MDDropdown from "../../../components/MDDropdown";
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "Settlement",
  components: {
    MDDropdown
  },
  data() {
    return {
      settelment: {
        wallet_id: 0,
        mdid22_status: 0,
        price: 0,
        wallet: {
          user: {}
        },
        user_card: {
          bank_name: {},
          user: {}
        }
      },
      doc: {},
      wallets: [],
      detaileds: [
        {
          text: "بانک دی به شماره حساب 0205137086000",
          value: 12
        },
        {
          text: "بانک پاسارگاد کارمزد ها به شماره حساب 13018100136827101",
          value: 13
        }
      ]
    };
  },
  methods: {
    SaveDoc() {
      this.doc.settlment_id = this.$route.params.id;
        httpHelper.postData("settlement/saveDoc" , this.doc).then(res => {
          this.$router.push("/rp/19");
        });
    }
  },
  mounted() {
    httpHelper.getData("settlement?id=" + this.$route.params.id).then(res => {
      this.settelment = res.result;
    });
    // httpHelper.getData("getlistByDetailType/713").then(res => {
    //   this.detaileds = res.result;
    // });
  }
};
</script>